module.exports = __webpack_public_path__ + "img/cloud-word.76878afc.svg";